import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import AlertBar from '../__header/AlertBar';
import sectionsInView from '../__header/sectionsInView';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		Video.init();
		mirrorHover();
		smoothScroll();
		Tables.init();
		viewportUnits();
		AlertBar();
		sectionsInView();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		viewportUnits();
	},
	resized() {
		Tables.toggleShadow();
		viewportUnits();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
